import ReactTable from 'react-table';
import withFixedColumns from 'react-table-hoc-fixed-columns';
import 'react-table/react-table.css';
import 'react-table-hoc-fixed-columns/lib/styles.css';
import './ReactTable.css';

const ReactTableFixedColumns = withFixedColumns(ReactTable);

export { ReactTable, ReactTableFixedColumns };
